import { Config } from "@resamare/models";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../config";

async function getConfig(): Promise<Config> {
    const response = await apiClient.get("/config");
    return response.data;
}

export function useGetConfig() {
    const query = useQuery({
        queryKey: ["config"],
        queryFn: getConfig,
        staleTime: Infinity,
    });

    return query;
}
